import classNames from 'classnames';

interface TabListProps {
  children: React.ReactNode;
  small?: boolean;
  extraSmall?: boolean;
  projectList?: boolean;
  search?: boolean;
  border?: boolean;
}

export default function TabList({ children, small, search, projectList, border, extraSmall }: TabListProps) {
  const tablistClasses = classNames('tablist', {
    'tablist--small': small,
    'tablist--search': search,
    'tablist--project-list': projectList,
    'tablist--border': border,
    'tablist--extra-small': extraSmall
  });

  return <div className={tablistClasses}>{children}</div>;
}
